import { Link } from "react-router";
import { all_routes } from "../../../router/all_routes";

interface Props {
    activeTab: 'TaxSettings';
}

const BillingSettingsMenu = ({activeTab}:Props) => {
    const routes = all_routes;


    return (
        <>
            <Link
                to={routes.taxSettings}
                className={`d-inline-flex align-items-center rounded py-2 px-3 ${activeTab === 'TaxSettings' ? 'active' : ''}`}
            >
                <i className="ti ti-arrow-badge-right me-2" />
                TAX Settings
            </Link>

        </>
    )
}

export default BillingSettingsMenu;

